import { render, staticRenderFns } from "./ChallengeIncludeTeams.vue?vue&type=template&id=19288e32&scoped=true&lang=pug&"
import script from "./ChallengeIncludeTeams.vue?vue&type=script&lang=js&"
export * from "./ChallengeIncludeTeams.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeIncludeTeams.vue?vue&type=style&index=0&id=19288e32&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19288e32",
  null
  
)

export default component.exports